import {
  fetchSessionHistory,
  selectSessionHistoryDataState,
  selectSessionHistoryHasNextPage,
  selectSessionHistoryItems,
  selectSessionHistoryLastTimestamp,
  selectSessionHistoryPageNumber,
  resetSessionLastTimestamp,
} from '../sessionHistory/sessionHistory.slice';
import {
  selectTransactionHistoryHasNextPage,
  selectTransactionHistoryPageNumber,
  selectTransactionHistoryItems,
  selectTransactionHistoryDataState,
  fetchTransactionHistory,
  selectTransactionHistoryLastTimestamp,
  resetTransactionsLastTimestamp,
  selectHasPaymentMethodsAwaitingDocumentReview,
  selectHasPaymentMethodsAwaitingDocumentVerification,
} from '../transactionHistory/transactionHistory.slice';
import {
  fetchGamingHistory,
  selectGamingHistoryHasNextPage,
  selectGamingHistoryPageNumber,
  selectGamingHistoryItems,
  selectGamingHistoryDataState,
  selectGamingHistoryLastTimestamp,
  resetGamingLastTimestamp,
} from '../gamingHistory/gamingHistory.slice';
import { HistoryStateFunctions, HistoryType } from './history.types';
import {
  fetchCoinsGamingHistory,
  resetCoinsGamingLastTimestamp,
  selectCoinsGamingHistoryDataState,
  selectCoinsGamingHistoryHasNextPage,
  selectCoinsGamingHistoryItems,
  selectCoinsGamingHistoryLastTimestamp,
  selectCoinsGamingHistoryPageNumber,
} from '../coinsGamingTransactionHistory/coinsGamingTransactionHistory.slice';

export const historyStateMap: Record<HistoryType, HistoryStateFunctions> = {
  [HistoryType.Transactions]: {
    hasNextPageSelector: selectTransactionHistoryHasNextPage,
    pageNumberSelector: selectTransactionHistoryPageNumber,
    itemsSelector: selectTransactionHistoryItems,
    lastTimestampSelector: selectTransactionHistoryLastTimestamp,
    dataStateSelector: selectTransactionHistoryDataState,
    fetchHistory: fetchTransactionHistory,
    resetLastTimestamp: resetTransactionsLastTimestamp,
    hasPaymentMethodsAwaitingDocumentReview:
      selectHasPaymentMethodsAwaitingDocumentReview,
    hasPaymentMethodsAwaitingDocumentVerification:
      selectHasPaymentMethodsAwaitingDocumentVerification,
  },
  [HistoryType.Sessions]: {
    hasNextPageSelector: selectSessionHistoryHasNextPage,
    pageNumberSelector: selectSessionHistoryPageNumber,
    itemsSelector: selectSessionHistoryItems,
    lastTimestampSelector: selectSessionHistoryLastTimestamp,
    dataStateSelector: selectSessionHistoryDataState,
    fetchHistory: fetchSessionHistory,
    resetLastTimestamp: resetSessionLastTimestamp,
  },
  [HistoryType.Gaming]: {
    hasNextPageSelector: selectGamingHistoryHasNextPage,
    pageNumberSelector: selectGamingHistoryPageNumber,
    itemsSelector: selectGamingHistoryItems,
    lastTimestampSelector: selectGamingHistoryLastTimestamp,
    dataStateSelector: selectGamingHistoryDataState,
    fetchHistory: fetchGamingHistory,
    resetLastTimestamp: resetGamingLastTimestamp,
  },
  [HistoryType.CoinGaming]: {
    hasNextPageSelector: selectCoinsGamingHistoryHasNextPage,
    pageNumberSelector: selectCoinsGamingHistoryPageNumber,
    itemsSelector: selectCoinsGamingHistoryItems,
    lastTimestampSelector: selectCoinsGamingHistoryLastTimestamp,
    dataStateSelector: selectCoinsGamingHistoryDataState,
    fetchHistory: fetchCoinsGamingHistory,
    resetLastTimestamp: resetCoinsGamingLastTimestamp,
  },
};
